import style from './block.module.scss'

export default function PTCard({ url, title, position, from}) {
    return (
        <div className={style.block}>
            <div className={style.cover}>
                {url && <img src={url} alt={title} />}
            </div>
            <div className={style.wrap}>
                <h3 className={style.title}>{title}</h3>
                <div className={style.meta}>{from} - {position}</div>
            </div>
        </div>
    )
}